import { render, staticRenderFns } from "./PowerSupplyCard.vue?vue&type=template&id=73f54a6a&scoped=true"
import script from "./PowerSupplyCard.vue?vue&type=script&lang=js"
export * from "./PowerSupplyCard.vue?vue&type=script&lang=js"
import style0 from "./PowerSupplyCard.scss?vue&type=style&index=0&id=73f54a6a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f54a6a",
  null
  
)

export default component.exports